import { useMutation } from '@tanstack/react-query'
import { gameBoxRoomService } from '../../../../services/games/games-boxes-rooms'

export const useEarningGameBoxRoom = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: gameBoxRoomService.earning,
  })

  return {
    earningGameBoxRoom: mutateAsync,
    isLoading: isPending,
  }
}
